import { render, staticRenderFns } from "./offers-details-page.vue?vue&type=template&id=1c1a9de8"
import script from "./offers-details-page.vue?vue&type=script&lang=js"
export * from "./offers-details-page.vue?vue&type=script&lang=js"
import style0 from "./offers-details-page.vue?vue&type=style&index=0&id=1c1a9de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports